// Module
var code = "<template> <dt-select options.bind=\"storageAreas\" id-field-name=\"id\" description-field-name=\"name\" value.bind=\"value\" label.bind=\"label\"></dt-select> </template> ";
// Exports
export default code;